import useMediaQuery from "@mui/material/useMediaQuery";

/** The three shells are pure width breakpoints (spec §2). */
export type Shell = "phone" | "tablet" | "desktop";

export const SHELL_QUERIES = {
  tabletUp: "(min-width:768px)",
  desktopUp: "(min-width:1100px)",
} as const;

/**
 * Resolve the active shell from the viewport width. Tablets follow width, not
 * device detection; there is no separate tablet information architecture.
 *
 * @returns phone below 768px, tablet 768–1099px, desktop at 1100px and up.
 */
export function useShell(): Shell {
  const tabletUp = useMediaQuery(SHELL_QUERIES.tabletUp);
  const desktopUp = useMediaQuery(SHELL_QUERIES.desktopUp);
  if (desktopUp) return "desktop";
  return tabletUp ? "tablet" : "phone";
}

/**
 * Whether a route's shell chrome is visible for the current session. The frame
 * exists while loading and on the login screen, but nav/search/headers only
 * make sense once a user is authenticated.
 *
 * @param auth the store's authentication status.
 * @returns true when the app chrome is shown.
 */
export function showsAppChrome(auth: string): boolean {
  return auth === "authenticated";
}
